import {
  textareaUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { remarksText } from '../definitions/constants';

export default {
  uiSchema: {
    'ui:options': { preserveHiddenData: true, forceDivWrapper: true },
    ...titleUI(remarksText.pageTitle, remarksText.pageDescription),
    remarks: textareaUI({
      title: remarksText.remarksTitle,
      required: () => false,
    }),

    'ui:order': ['remarks'],
  },
  schema: {
    type: 'object',
    properties: {
      remarks: {
        type: 'string',
      },
    },
    required: [],
  },
};
